interface Props {
  size?: number;
  className?: string;
  /** colors come from currentColor (sail) and currentColor (hull) — pass parent text color */
}

/**
 * Minimalist sailboat:
 *   - Main sail (right of mast): solid triangle
 *   - Jib (left of mast): light triangle
 *   - Hull: trapezoidal sweep
 *   - Optional water line below
 *
 * Designed to read at 16-px favicon and 64-px header alike.
 */
export default function Logo({ size = 24, className = "" }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Logbuch"
    >
      {/* Mast */}
      <line
        x1="16"
        y1="3.5"
        x2="16"
        y2="20"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      {/* Main sail (right of mast) */}
      <path d="M16 5 L16 19 L25.5 19 Z" fill="currentColor" />
      {/* Jib (left of mast, lighter) */}
      <path d="M16 8.5 L16 19 L7.5 19 Z" fill="currentColor" opacity="0.45" />
      {/* Hull */}
      <path
        d="M4 21.5 L28 21.5 L25 26 L7 26 Z"
        fill="currentColor"
      />
      {/* Water line */}
      <path
        d="M2.5 28.5 Q8 27 13 28.5 T24 28.5 T29.5 28"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        fill="none"
        opacity="0.4"
      />
    </svg>
  );
}
